import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { ADMIN } from "../../config/constants";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import { navigateTo, checkOpenPayment } from "./OpenPayment.ducks";
// Components
import { fetchAppFeatureSettings } from "../../services/clientSettings.ducks";

class OpenPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasOpenPayment: true,
      hasRecentPayment: false,
      paymentSuccess: false
    };
  }

  async componentDidMount() {
    //this.checkIsOpenPayment();

    const { fetchAppFeatureSettings, navigateTo } = this.props;
    const appFeatureSettings = await fetchAppFeatureSettings();

    if (appFeatureSettings.hasActivePayment) {
      this.updateTimer = setInterval(() => this.checkIsOpenPayment(), 5000);
    } else {
      navigateTo("/dashboard/bookings");
      return null;
    }
  }

  componentWillUnmount() {
    clearInterval(this.updateTimer);
  }

  checkIsOpenPayment = async () => {
    const { checkOpenPayment } = this.props;
    const paymentStatus = await checkOpenPayment();

    if (paymentStatus.hasOpenPayment === false) {
      clearInterval(this.updateTimer);
    }

    this.setState({
      hasOpenPayment: paymentStatus.hasOpenPayment,
      hasRecentPayment: paymentStatus.hasRecentPayment,
      paymentSuccess: paymentStatus.paymentSuccess
    });
  };

  leaveDialogue() {
    const { navigateTo } = this.props;

    navigateTo("/dashboard/bookings");
    return null;
  };

  render() {
    const { auth, t } = this.props;
    const { hasOpenPayment, hasRecentPayment, paymentSuccess } = this.state;

    if (hasOpenPayment === true) {

      return (
        <div style={{ alignItems: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", position: "fixed", top: 0, width: "100%" }}>
          <i className="fa fa-circle-o-notch fa-spin text-primary" style={{ fontSize: 100, padding: "20px" }} />
          <span className="h2"><strong>{t(`modules.localization.register.authenticated.payment.open.header`)}</strong></span>
          <span className="h3" style={{ margin: "0px 10px", textAlign: "center" }}>{t(`modules.localization.register.authenticated.payment.open.text`)}</span>
        </div>
      );

    } else {

      const isAdmin = auth.role === ADMIN;
      const buttonLabelL10n = isAdmin ? 'modules.localization.register.generals.button.backTo.candidateOverview'
                                      : 'modules.localization.register.generals.button.backTo.myBookings';

      if (hasRecentPayment === true) {
        if (paymentSuccess === true) {

          return (
            <div style={{ alignItems: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", position: "fixed", top: 0, width: "100%" }}>
              <i className="fa fa-check text-success" style={{ fontSize: 100, padding: "20px" }} />
              <span className="h3"><strong>{t(`modules.localization.register.authenticated.payment.success.header`)}</strong></span>
              <span className="h4" style={{ margin: "0px 10px", textAlign: "center" }}>{t(`modules.localization.register.authenticated.payment.success.text`)}</span>
              <button className="btn  btn-primary" onClick={() => { this.leaveDialogue(); }} style={{ margin: "40px" }} type="button">{t(buttonLabelL10n)}</button>
            </div>
          );

        } else {

          return (
            <div style={{ alignItems: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", position: "fixed", top: 0, width: "100%" }}>
              <i className="fa fa-times text-danger" style={{ fontSize: 100, padding: "20px" }} />
              <span className="h3"><strong>{t(`modules.localization.register.authenticated.payment.fail.header`)}</strong></span>
              <span className="h4" style={{ margin: "0px 10px", textAlign: "center" }}>{t(`modules.localization.register.authenticated.payment.fail.text`)}</span>
              <button className="btn btn-primary" onClick={() => { this.leaveDialogue(); }} style={{ margin: "40px" }} type="button">{t(buttonLabelL10n)}</button>
            </div>
          );

        }
      } else {

        const noRecentPaymentTextL10n = isAdmin ? 'modules.localization.register.authenticated.payment.noRecentPayment.text.administration'
                                                : 'modules.localization.register.authenticated.payment.noRecentPayment.text.candidate';

        return (
          <div style={{ alignItems: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", position: "fixed", top: 0, width: "100%" }}>
            <i className="fa fa-credit-card text-primary" style={{ fontSize: 100, padding: "20px" }} />
            <span className="h3"><strong>{t(`modules.localization.register.authenticated.payment.noRecentPayment.header`)}</strong></span>
            <span className="h4" style={{ margin: "0px 10px", textAlign: "center" }}>{t(noRecentPaymentTextL10n)}</span>
            <button className="btn  btn-primary" onClick={() => { this.leaveDialogue(); }} style={{ margin: "40px" }} type="button">{t(buttonLabelL10n)}</button>
          </div>
        );

      }
    }
  }
}

OpenPayment.propTypes = {
  navigateTo: PropTypes.func.isRequired,
  checkOpenPayment: PropTypes.func.isRequired,
  fetchAppFeatureSettings: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isOpenPayment: state.isOpenPayment,
  auth: state.auth
});

const mapDispatchToProps = {
  navigateTo,
  checkOpenPayment,
  fetchAppFeatureSettings
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(OpenPayment);
